const axios = require("axios")

const data = {
  siteId: process.env.GATSBY_SITE_ID,
  accessId: process.env.GATSBY_ACCESS_ID,
}

const getStockDetails = async () => {
  try {
    const response = await axios.post(process.env.GATSBY_STOCK_URL, data, {
      headers: {
        appid: process.env.GATSBY_STOCKAPP_ID,
        "Content-Type": "application/json",
      },
    })
    
    return response?.data?.data || []
  } catch (error) {
    console.error(error.message)
  }
}

module.exports = { getStockDetails }
